import { render, staticRenderFns } from "./BaseColoredLabel.vue?vue&type=template&id=31cea256&scoped=true&"
import script from "./BaseColoredLabel.vue?vue&type=script&lang=js&"
export * from "./BaseColoredLabel.vue?vue&type=script&lang=js&"
import style0 from "./BaseColoredLabel.vue?vue&type=style&index=0&id=31cea256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cea256",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
